// ===========================================
// Calendar Resource Header
// ===========================================

import { Box, Typography } from '@mui/material';
import { CalendarResource } from './calendar.types';

interface CalendarResourceHeaderProps {
  label: string;
  resource: CalendarResource;
}

export default function CalendarResourceHeader({
  label,
  resource,
}: CalendarResourceHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        py: 0.5,
      }}
    >
      {resource.color && (
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: resource.color,
            border: '1px solid rgba(0,0,0,0.2)',
            flexShrink: 0,
          }}
        />
      )}
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
    </Box>
  );
}
